document.addEventListener('click', function (e) {

  const productBlock = e.target.closest('.product-block');
  if (!productBlock) return;

  const productId = productBlock.dataset.productId;
  const sizeBox = productBlock.querySelector(`#variant-sizes-${productId}`);

  /* ===============================
     CLOSE ICON CLICK
  =============================== */
  const closeBtn = e.target.closest('.variant-sizes-close');
  if (closeBtn) {
    e.preventDefault();
    e.stopPropagation();

    sizeBox?.classList.remove('active');
    return;
  }

  /* ===============================
     MOBILE + PLUS BUTTON CLICK
  =============================== */
  const addBtn = e.target.closest('button.add-to-cart-btn');
  if (addBtn) {
    if (window.innerWidth > 1024) return;

    e.preventDefault();
    e.stopPropagation();

    document.querySelectorAll('.variant-sizes.active').forEach(el => {
      if (el !== sizeBox) el.classList.remove('active');
    });

    sizeBox?.classList.toggle('active');
    return;
  }

  /* ===============================
     SIZE CLICK → ADD TO CART
  =============================== */
  const sizeBtn = e.target.closest('.variant-size-btn');
  if (sizeBtn) {
    e.preventDefault();
    e.stopPropagation();

    const variantId = sizeBtn.dataset.variantId;
    if (!variantId) return;

    const originalText = sizeBtn.textContent;
    sizeBtn.textContent = 'Adding...';
    sizeBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(r => r.json())
      .then(() => fetch('/?sections=cart-drawer,cart-icon-bubble'))
      .then(r => r.json())
      .then(sections => {

        const parser = new DOMParser();

        const drawer = parser
          .parseFromString(sections['cart-drawer'], 'text/html')
          .querySelector('cart-drawer');

        const currentDrawer = document.querySelector('cart-drawer');
        if (drawer && currentDrawer) currentDrawer.replaceWith(drawer);

        const bubble = parser
          .parseFromString(sections['cart-icon-bubble'], 'text/html')
          .querySelector('.cart-count-bubble');

        const currentBubble = document.querySelector('.cart-count-bubble');
        if (bubble && currentBubble) currentBubble.replaceWith(bubble);

        document.querySelector('cart-drawer')?.open();
        sizeBox?.classList.remove('active');

        sizeBtn.textContent = 'Added ✓';
        setTimeout(() => {
          sizeBtn.textContent = originalText;
          sizeBtn.disabled = false;
        }, 900);
      })
      .catch(() => {
        sizeBtn.textContent = 'Error';
        setTimeout(() => {
          sizeBtn.textContent = originalText;
          sizeBtn.disabled = false;
        }, 1200);
      });

    return;
  }

});
